/**
 * Role names that carry super-admin authority.
 *
 * `super_profit_iq` is `super` plus the Profit IQ bit. Bitmask checks
 * (`checkPermission(SUPER)`) already accept it, since `SUPER` is a subset
 * probe, but checks written against the role *name* have to list it too or a
 * super-profit user silently loses super-only features.
 */
const SUPER_ROLE_NAMES = ['super', 'super_profit_iq'];

/**
 * @param {{ name?: string }} [role] the populated role, e.g. `currentBusiness.roles`
 */
export const isSuperRole = (role) => SUPER_ROLE_NAMES.includes(role?.name);

export default isSuperRole;
